import React from "react";
import styles from "./ReportsAnalytics.module.scss";
import { Container, Row, Col } from "reactstrap";
import StatsCard from "../../../components/AffiliatePortalComponents/ReportsAnalytics/StatsCard/StatsCard";
import MonthlyEarnings from "../../../components/AffiliatePortalComponents/ReportsAnalytics/MonthlyEarnings/MonthlyEarnings";
import ClicksImg from "../../../assets/images/AffliliatePortal/ReportsAnalyticsImgs/clicksImg.png";
import ConversionsImg from "../../../assets/images/AffliliatePortal/ReportsAnalyticsImgs/conversionsImg.png";
import ReferralsImg from "../../../assets/images/AffliliatePortal/ReportsAnalyticsImgs/referralsImg.png";
import LineGraph from "../../../components/AffiliatePortalComponents/ReportsAnalytics/LineGraph/LineGraph";
import ConversionRates from "../../../components/AffiliatePortalComponents/ReportsAnalytics/ConversionRates/ConversionRates";

const earningsLineChartData = [
    { value: 10 },
    { value: 25 },
    { value: 18 },
    { value: 35 },
    { value: 50 },
    { value: 60 },
];

const conversionsLineChartData = [
    { value: 5 },
    { value: 15 },
    { value: 10 },
    { value: 20 },
    { value: 25 },
    { value: 30 },
];

const conversionRatesData = [
    { percentageValue: 60, content: "Conversion rate by Social Media", color: "#2bb673" },
    { percentageValue: 40, content: "Conversion Rate by Website", color: "#f1592a" },
];

const ReportsAnalytics = () => {
    const statsData = [
        {
            icon: ClicksImg,
            title: "Total Clicks",
            thisMonth: "1,500",
            overall: "6,000",
            percentage: 75,
            color: "#00aeef",
        },
        {
            icon: ConversionsImg,
            title: "Total Conversions",
            thisMonth: "120",
            overall: "3,500",
            percentage: 55,
            color: "#2bb673",
        },
        {
            icon: ReferralsImg,
            title: "New Referrals",
            thisMonth: "1,500",
            overall: "5,000",
            percentage: 30,
            color: "#f1592a",
        },
    ];

    return (
        <Container fluid className={styles.mainContainer}>
            <h3 className={styles.mainHeading}>Reports and Analytics</h3>
            <Row className="g-0 row-gap-4">
                <Col xxl={9} className="pe-xxl-3">
                    <Row className={styles.statsCardsRow}>
                        {statsData.map((item, index) => (
                            <Col key={index}>
                                <StatsCard {...item} />
                            </Col>
                        ))}
                    </Row>
                    <Row className="g-0">
                        <MonthlyEarnings />
                    </Row>
                </Col>
                <Col xxl={3} className="ps-xxl-3">
                    <Row className="g-0 mb-4">
                        <Col>
                            <div className={styles.balanceContainer}>
                                <h4 className={styles.sectionHeading}>Current Balance</h4>
                                <h2 className={styles.balanceValue}>$6,500</h2>

                                <p className={styles.balanceText}>Earnings this month</p>
                                <h4 className={styles.balanceValue}>$1,500</h4>
                                <LineGraph data={earningsLineChartData} color="#0db4ff" percentage={20} />

                                <p className={styles.balanceText}>Conversions this month</p>
                                <h4 className={styles.balanceValue}>120</h4>
                                <LineGraph data={conversionsLineChartData} color="#0db4ff" percentage={10} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="g-0">
                        <Col>
                            <ConversionRates conversionRatesData={conversionRatesData} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default ReportsAnalytics;